import { render } from "./OfferFlats.vue?vue&type=template&id=4e9ddec0"
import script from "./OfferFlats.vue?vue&type=script&lang=js"
export * from "./OfferFlats.vue?vue&type=script&lang=js"

import exportComponent from "/Users/martin/www/forton/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__